import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "components__rec-plain-text" }

import { recProps } from '../../mixins/rec-component';
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-plain-text',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.description.content), 1))
}
}

})